<agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
    <ng-container *ngFor="let m of markers; let i = index">

        <agm-marker (markerClick)="clickedMarker(m.label, i)" [latitude]="m.lat" [longitude]="m.lng" [label]="m.label"
            [iconUrl]="$any(m.icon)" *ngIf="m.isShown">

            <agm-info-window>
                <div class="card" routerLink="/listing/details/{{m.id}}">
                    <img class="marker-item" appLazyload [src]="m.images ? ((m.images[0] | imageUrl) | async) : ''">
                    <ng-template #noImage>
                        <div [ngStyle]="getBackgroundImageStyle(null)" class="listing-item"></div>
                    </ng-template>
                    <div class="card-body">
                        <h5 class="card-title">{{ m.name ? m.name : 'No Title' }}</h5>
                        <p class="card-text">${{ m.rentalPrice }} /day</p>
                        <label class="location pin">
                            <img src="./assets/images/map-pin.svg" />
                            {{ m.content ? m.content: 'No Location specified' }}
                        </label>
                    </div>
                </div>

            </agm-info-window>

        </agm-marker>

    </ng-container>
<!-- 
    <agm-circle [latitude]="radiusLat" [longitude]="radiusLong" [radius]="radius" [fillColor]="'green'"
        [circleDraggable]="true" [editable]="false" (dragEnd)="radiusDragEnd($event)"
        (radiusChange)="event('radiusChange',$event)">
    </agm-circle> -->

</agm-map>